import { motion } from "framer-motion";
import { ArrowUpRight, CalendarCheck } from "lucide-react";
import { Button } from "@/components/ui/button";
import { enterUp } from "@/lib/motion";
import { IMAGES, LINKS } from "@/data/content";

const HERO_IMAGE_ENTER = { initial: { opacity: 0 }, animate: { opacity: 1 }, transition: { duration: 0.9, delay: 0.2 } };

export const Hero = () => (
  <section id="top" data-testid="hero-section" className="grid pt-20 lg:min-h-[calc(100vh-5rem)] lg:grid-cols-2">
    <div className="flex items-center px-5 py-16 sm:px-8 lg:py-24 lg:pl-8 lg:pr-16">
      <div className="max-w-xl">
        <motion.h1 {...enterUp(0.1)} data-testid="hero-headline" className="font-heading text-2xl font-bold leading-[1.1] tracking-tight text-ink sm:text-3xl">
          Supporting all your recruitment wants and needs<span className="text-navy">.</span>
        </motion.h1>
        <motion.p {...enterUp(0.2)} data-testid="hero-tagline" className="mt-6 font-heading text-lg font-semibold text-navy md:text-lg">
          Here when you're slammed, gone when you're not.
        </motion.p>
        <motion.p {...enterUp(0.28)} data-testid="hero-description" className="mt-4 text-base leading-relaxed text-ink/70 sm:text-lg">
          PKR is your all-in recruiting team. We plug into your team when you need backup or run the show when you don't have one. Scale up, down, in or out.
        </motion.p>
        <motion.div {...enterUp(0.36)} className="mt-10 flex flex-col gap-3 sm:flex-row sm:items-center">
          <Button asChild data-testid="hero-cta-calendly" className="btn-primary h-13 px-7 text-base">
            <a href={LINKS.calendly} target="_blank" rel="noopener noreferrer">
              <CalendarCheck className="mr-2 h-5 w-5" /> Book a consultation
            </a>
          </Button>
          <Button asChild variant="ghost" data-testid="hero-cta-careers" className="btn-ghost h-13 px-6 text-base">
            <a href={LINKS.careers} target="_blank" rel="noopener noreferrer">
              View open positions <ArrowUpRight className="ml-1.5 h-4 w-4" />
            </a>
          </Button>
        </motion.div>
      </div>
    </div>

    <motion.div
      {...HERO_IMAGE_ENTER}
      className="relative h-[60vw] max-h-[560px] lg:h-auto lg:max-h-none"
    >
      <img
        src={IMAGES.hero}
        alt="Recruiting team collaborating in a modern office"
        data-testid="hero-image"
        className="absolute inset-0 h-full w-full object-cover"
      />
      <div data-testid="hero-floating-stat" className="absolute bottom-8 left-8 bg-white px-6 py-4">
        <p className="font-heading text-2xl font-bold text-navy">98%</p>
        <p className="text-xs font-medium uppercase tracking-[0.14em] text-ink/60">of clients return</p>
      </div>
    </motion.div>
  </section>
);
